var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "overlay" },
    [
      _c(
        "transition",
        {
          attrs: { name: _vm.overlay.transition },
          on: {
            enter: _vm.onScrollLockEnterHook,
            afterLeave: _vm.onScrollLockAfterLeaveHook
          }
        },
        [
          _vm.overlay.isOpen
            ? _c("div", { staticClass: "overlay--root" }, [
                _c("div", { staticClass: "overlay--backdrop" }),
                _vm._v(" "),
                _c("div", { staticClass: "overlay--display" }, [
                  _c("div", { staticClass: "overlay--wrap-outer" }, [
                    _c("div", { staticClass: "overlay--wrap-inner" }, [
                      _c("div", {
                        staticClass: "overlay--backdrop-click-area",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            _vm.closeOverlay($event)
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "overlay--container" }, [
                        _c(
                          "div",
                          { staticClass: "overlay--revealer" },
                          [
                            _c(
                              "cmp-modal",
                              { attrs: { facet: _vm.overlay.facet } },
                              [
                                _c(
                                  _vm.overlay.component,
                                  _vm._b(
                                    { tag: "component" },
                                    "component",
                                    _vm.overlay.props,
                                    false
                                  )
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    ])
                  ])
                ])
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e402b83", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e402b83","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./vehi-industriepfad/assets/src/js/app/framework/components/ui/overlay/index.vue
// module id = 442
// module chunks = 5